import {Button, Row} from "antd";
import {jsonParse} from "helper/common";
import React, {useEffect, useState} from "react";
const ModalConfirm = props => {
  const {onConfirm, closeModal, idPhong} = props;
  const [tenPhong, setTenPhong] = useState();
  useEffect(() => {
    const _tenPhong = jsonParse(
      localStorage.getItem("phongKhamNoPeople")
    )?.find(e => e?.value == idPhong)?.label;
    setTenPhong(_tenPhong);
  }, [idPhong]);
  return (
    <div>
      <Row justify={"center"}>
        <div>
          {" "}
          Xác nhận chuyển bệnh nhân đến{" "}
          <span style={{fontWeight: "bold"}}>{tenPhong}</span> ?
        </div>
      </Row>
      <Row justify={"end"}>
        <Button
          type="primary"
          onClick={async () => {
            try {
              await onConfirm();
              closeModal();
            } catch (error) {
              closeModal();
            }
          }}
        >
          Xác nhận
        </Button>
      </Row>
    </div>
  );
};
export {ModalConfirm};
